import React from "react"

import ProductCarousel from '../components/product-carousel'
import FeaturedProducts from "../components/featured-products"
import TrendingOffers from "../components/trending-offers"
import BrowseCategories from "../components/browse-categories"
import Hero from "../components/hero"
import HardCodedProductCarousel from '../components/hard-coded-product-carousel'
import SubscribeAndSave from '../components/subscribe-and-save'
import useGetHomepageContent from '../hooks/useGetHomepageContent'
import CriteoHome from "../criteo/home"

export const Head = () => {
	return (
		<>
			<title>Home Page</title>
			<CriteoHome />
		</>
	)
}

export default function Index() {
	const {
		sale_bar,
		banner,
		hero_products,
		hero_title,
		featured_products,
		sale_products,
		collection_products,
		trending_offer_title,
		trending_offer,
		browser_category_title,
		browser_category_desc,
	} = useGetHomepageContent()

	return (
		<>
			{/* <div dangerouslySetInnerHTML={{__html: sale_bar}} /> */}
			{/* <div dangerouslySetInnerHTML={{__html: banner}} /> */}
			<Hero />
			<HardCodedProductCarousel />
			{/* <ProductCarousel ids={hero_products} /> */}
			<FeaturedProducts
				title={hero_title}
				ids={featured_products}
				sale_ids={sale_products}
				collection_ids={collection_products}
			/>
			<TrendingOffers
				title={trending_offer_title}
				ids={trending_offer}
			/>
			<BrowseCategories
				title={browser_category_title}
				description={browser_category_desc}
			/>
			<SubscribeAndSave />
		</>
	)
}
